import React from 'react';

const Notfound = () => {
    return (
        <div className="text-white">
            <h1>404</h1>
            <h3>Page not found</h3>
        </div>
    );
};

export default Notfound;